import DatePicker from 'react-datepicker';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 RANGO DE FECHAS — un solo calendario, dos extremos

    selectsRange hace que el mismo picker devuelva [desde, hasta].
    Es mejor que dos campos separados: el usuario ve el rango pintado
    mientras elige y no puede poner el fin antes del inicio.
*/

export const FieldDateRange = ({
    id, label, hint, error,
    value = [null, null], onChange,
    placeholder = 'dd/mm/aaaa — dd/mm/aaaa',
    dateFormat = 'dd/MM/yyyy',
    minDate = null, maxDate = null, months = 2,
    isRequired = false, isDisabled = false,
    span = 2, ...rest
}) => {

    const [FROM, TO] = value;

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isRequired={isRequired} isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__wrap ${BLOCK}__wrap--date`}>

                <DatePicker
                    id={DOM_ID} name={DOM_NAME} autoComplete="nope"
                    className={`${BLOCK}__input`}
                    wrapperClassName={`${BLOCK}__dp_wrap`}
                    calendarClassName="LS__dp"
                    popperClassName="LS__dp_popper"
                    selectsRange
                    startDate={FROM} endDate={TO}
                    onChange={onChange}
                    placeholderText={placeholder}
                    dateFormat={dateFormat}
                    monthsShown={months}
                    minDate={minDate} maxDate={maxDate}
                    locale="es"
                    disabled={isDisabled}
                    autoComplete={FIELD_AUTOCOMPLETE_OFF}
                    showPopperArrow={false}
                    isClearable
                    {...rest}
                />

                <span className={`${BLOCK}__icon ${BLOCK}__icon--end`} aria-hidden="true">
                    <FaRegCalendarAlt />
                </span>

            </div>

        </FieldShell>
    );
};
